module.exports = __webpack_public_path__ + "media/images/flags/HK-0c500b32f790401fb3b6a3fd8f618e18.svg";